AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Toc");

AoPS.Ebooks.Views.Toc = (function (EbkVToc) {
	// Dependencies
	var EbkVBase = AoPS.Ebooks.Views.Base;

	// Model should be a book. Available options: item_size, total_size,
	// should_fill_div, horiz, is_free_preview. Only one of the first three need to be set.
	EbkVToc.Bar = EbkVBase.BaseView.extend({
		ITEM_MARGIN: 2, // Copied from CSS
		MIN_SECTIONS: 3, // Bump up size when chapter has fewer sections than this

		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-toc-bar");

			this.total_size = options.total_size;
			this.should_fill_div = options.should_fill_div;
			this.item_size = options.item_size || 5;
			this.horiz = !!options.horiz;
			this.is_free_preview = options.is_free_preview;
			this.current_section = null;

			this.item_views = [];

			this.model.requestLoad(function (ok) {
				if (!ok) {
					return;
				}
				this.createItemSubviews();
				this.render();
			}, this);

			var master = this.model.get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.renderLoading(null);
		},

		setCurrentSection: function (section) {
			this.current_section = section;
			_.each(this.item_views, function (item_view) {
				item_view.setCurrentSection(section);
			});
		},

		setItemSizes: function () {
			if (this.should_fill_div) {
				this.total_size = parseInt(this.$el.width(), 10);
			}

			var item_sizes = this.computeItemSizes();
			_.each(this.item_views, function (item_view, i) {
				item_view.setTotalSize(item_sizes[i]);
			});
		},

		computeItemSizes: function () {
			var chapter_counts = this.model.get("chapters").map(function (chapter) {
				return Math.max(chapter.get("sections").length, this.MIN_SECTIONS);
			}, this);

			if (!this.total_size) {
				return chapter_counts.map(function (count) {
					return count * this.item_size;
				}, this);
			}

			var total_margin = this.model.get("chapters").length * this.ITEM_MARGIN;
			var total_count = _.reduce(
				chapter_counts,
				function (acc, count) {
					return acc + count;
				},
				0
			);

			var adjusted_size = this.total_size - total_margin;
			var curr_pos = 0;
			return _.map(
				chapter_counts,
				function (count, i) {
					var frac_size = (adjusted_size * count) / total_count;
					var orig_pos = curr_pos;
					curr_pos += frac_size;
					return Math.round(curr_pos) - Math.round(orig_pos);
				},
				this
			);
		},

		createItemSubviews: function () {
			var item_sizes = this.computeItemSizes();
			this.clearLocation("@item");
			this.item_views = [];

			this.model.get("chapters").each(function (chapter, i) {
				var view_obj = new EbkVToc.Item({
					model: chapter,
					current_section: this.current_section,
					horiz: this.horiz,
					is_free_preview: this.is_free_preview,
					total_size: item_sizes[i],
				});
				this.item_views.push(view_obj);
				this.addSubviewToLocation(view_obj, "@item");
			}, this);
		},

		postRender: function () {
			this.setItemSizes();
			this.$el.toggleClass("ebk--horiz", this.horiz);

			if (!this.delayedRecompute) {
				this.delayedRecompute = _.debounce(
					_.bind(this.setItemSizes, this),
					100
				);
				$(window).off("resize", this.delayedRecompute);
			}
			$(window).on("resize", this.delayedRecompute);
		},

		onOfflineChange: function (master_model, is_offline) {
			_.each(
				this.item_views,
				function (item_view) {
					item_view.links_enabled = !is_offline;
				},
				this
			);
		},
	});

	EbkVToc.Item = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-toc-bar-item");

			this.current_section = options.current_section || null;
			this.total_size = options.total_size;
			this.horiz = !!options.horiz;
			this.is_free_preview = options.is_free_preview;
			this.hover_section = null;
			this.links_enabled = true;

			this.render();
		},

		getContext: function () {
			return {
				label: this.model.getTocNumber(),
			};
		},

		postRender: function () {
			this.updateElSize();

			this.$el.toggleClass("ebk--horiz", this.horiz);
			this.updateOrderClass();

			this.hover_tip = this.$(".ebk--hover-tip");
			this.hover_tip.toggle(!!this.hover_section);

			this.$el.addClass("ebk-pointer");
			this.$el.on("click", _.bind(this.onClick, this));
			this.$el.on("mousemove", _.bind(this.onMove, this));
			this.$el.on("mousewheel", _.bind(this.clearHoverSection, this));
			this.$el.on("mouseleave", _.bind(this.clearHoverSection, this));
		},

		getEventPosition: function (event) {
			if (this.horiz) {
				return event.pageX - this.$el.offset().left;
			} else {
				return event.pageY - this.$el.offset().top;
			}
		},

		getHoverSection: function (pos) {
			// var ind = pos / this.item_size;
			var ind = this.model.get("sections").length * (pos / this.total_size);
			ind = Math.floor(ind);
			return this.model.get("sections").at(ind);
		},

		setCurrentSection: function (section) {
			this.current_section = section;
			this.updateOrderClass();
		},

		setTotalSize: function (total_size) {
			this.total_size = total_size;
			this.updateElSize();
			this.clearHoverSection();
		},

		updateElSize: function () {
			this.$el.css(this.horiz ? "width" : "height", this.total_size + "px");
		},

		updateOrderClass: function () {
			var item_order = this.model.get("order");
			var shown_order = -100;
			if (this.current_section) {
				shown_order = this.current_section.get("chapter").get("order");
			}

			this.$el.removeClass("ebk--passed ebk--later ebk--current");
			if (item_order < shown_order) {
				this.$el.addClass("ebk--passed");
			} else if (item_order > shown_order) {
				this.$el.addClass("ebk--later");
			} else {
				this.$el.addClass("ebk--current");
			}
		},

		clearHoverSection: function () {
			this.hover_section = null;
			this.hover_tip.hide();
		},

		onMove: function (event) {
			var pos = this.getEventPosition(event);
			var section = this.getHoverSection(pos);
			var hover_size = this.horiz
				? this.hover_tip.width()
				: this.hover_tip.height();
			var hover_pos = pos - hover_size / 2 - 4;

			if (!section) {
				this.hover_tip.hide();
			} else if (!this.hover_section || section.id !== this.hover_section.id) {
				this.hover_section = section;
				this.hover_tip.find("div").html(section.getNumberTitle());
				this.hover_tip.css(this.horiz ? "left" : "top", hover_pos + "px");
				this.hover_tip.show();
			}
		},

		onClick: function (event) {
			if (this.is_free_preview) {
				EbkVBase.showFreePreviewModal(
					"preview-toc-navigation",
					this.model.get("book")
				);
			} else if (this.hover_section && this.links_enabled) {
				$(window).scrollTop(0);
				Backbone.trigger(
					"ebk_goto_section",
					this.model.get("book"),
					this.hover_section.id
				);
			}
		},
	});

	return EbkVToc;
})(AoPS.Ebooks.Views.Toc);
